'use client'

import Button from '@/components/ui/Button'
import { updatePassword } from '@/utils/saas/auth-helpers/server'
import { handleRequest } from '@/utils/saas/auth-helpers/client'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

interface UpdatePasswordProps {
  redirectMethod: string
}

export default function UpdatePassword({
  redirectMethod,
}: Readonly<UpdatePasswordProps>) {
  const tmpRouter = useRouter()
  const router = redirectMethod === 'client' ? tmpRouter : null
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    setIsSubmitting(true) // Disable the button while the request is being handled
    await handleRequest(e, updatePassword, router)
    setIsSubmitting(false)
  }

  return (
    <div className="my-8">
      <form
        noValidate={true}
        className="mb-4"
        onSubmit={(e) => {
          // NOTE: Intentionally not awaited.
          void handleSubmit(e)
        }}
      >
        <div className="grid gap-2">
          <div className="grid gap-1">
            <label htmlFor="password">New Password</label>
            <input
              id="password"
              placeholder="Password"
              type="password"
              name="password"
              autoComplete="current-password"
              className="w-full p-3 rounded-md bg-zinc-200 dark:bg-zinc-800"
            />
            <label htmlFor="passwordConfirm">Confirm New Password</label>
            <input
              id="passwordConfirm"
              placeholder="Password"
              type="password"
              name="passwordConfirm"
              autoComplete="current-password"
              className="w-full p-3 rounded-md bg-zinc-200 dark:bg-zinc-800"
            />
          </div>
          <Button
            id="update-password"
            variant="slim"
            type="submit"
            className="mt-1"
            loading={isSubmitting}
          >
            Update Password
          </Button>
        </div>
      </form>
    </div>
  )
}
